import React, { useState, useEffect } from 'react';
import { AnglesUp } from '../../icons/FontAwesomeIcon';
import '../../styles/components/BackToTop.css';

export default function BackToTop() {
    const [isVisible, setIsVisible] = useState(false);

    const toggleVisibility = () => {
        const scrollHeight = document.documentElement.scrollHeight;
        const scrollTop = window.scrollY;
        const clientHeight = window.innerHeight;

        // Calculate how much the user has scrolled
        const scrolledPercentage = (scrollTop + clientHeight) / scrollHeight;

        // Show icon when scrolled past 80% of the page
        if (scrolledPercentage > 0.8) {
            setIsVisible(true);
        } else {
            setIsVisible(false);
        }
    };

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

    useEffect(() => {
        window.addEventListener('scroll', toggleVisibility);
        return () => {
            window.removeEventListener('scroll', toggleVisibility);
        };
    }, []);

    return (
        <div
            className={`back-to-top ${isVisible ? 'fade-in' : 'fade-out'}`}
            onClick={scrollToTop}
            id="scrollUp"
        >
            <AnglesUp />
        </div>
    );
}
